import { Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, Grid, IconButton, Typography, TextField } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { dateWithTime, imageToBase64 } from '../config'
import { useAuth, useUser } from '../context'
import { useAlertContext } from '../context/Alert.context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera, faImage, faPen, faCheck } from '@fortawesome/free-solid-svg-icons'
import 'swiper/css'
import ImageAstDialog from './ImageAstDialog'
import { CameraModal } from '../modals'

const BacklogMessageDialog = ({ open, close, itemReport, index, report }) => {
    const { userData } = useAuth()
    const { isOperator, isUniversalChief } = useUser()
    const { setConfirm } = useAlertContext()
    const [item, setItem] = useState()
    const [images, setImages] = useState([])
    const [openImageModel, setOpenImageModel] = useState(false)
    const [imagesSelected, setImagesSelected] = useState([])
    const [indexImage, setIndexImage] = useState(0)
    const [seleccionComponente, setSeleccionComponente] = useState('nuevoBacklog')
    const [openCamera, setOpenCamera] = useState(false)
    const [galleryImageToEdit, setGalleryImageToEdit] = useState(null)
    const [hasLocalChanges, setHasLocalChanges] = useState(false)
    const [editingIndex, setEditingIndex] = useState(null)
    const [editingText, setEditingText] = useState('')

    const currentUserId = userData?._id
    const userHasStarted = report?.ejecuciones?.some(
        (e) =>
            (e.userId?._id || e.userId)?.toString() === currentUserId?.toString() &&
            e.termino === null
    )

    const handleStartEditMessage = (idx, currentContent) => {
        setEditingIndex(idx)
        setEditingText(currentContent || '')
    }

    const handleSaveEditMessage = (idxToEdit) => {
        if (!editingText.trim()) return
        const updatedBacklogList = item.backlogList.map((m, i) => {
            if (i === idxToEdit) {
                return { ...m, message: editingText.trim() }
            }
            return m
        })
        const updatedItem = {
            ...item,
            backlogList: updatedBacklogList
        }
        setItem(updatedItem)
        setHasLocalChanges(true)
        setEditingIndex(null)
        setEditingText('')
    }

    useEffect(() => {
        if (isOperator && !isUniversalChief && (!report.level || report.level === 0) && userHasStarted) {
            setSeleccionComponente('nuevoBacklog')
        } else {
            setSeleccionComponente('mensajes')
        }
    }, [isOperator, isUniversalChief, itemReport, report.level, userHasStarted])

    useEffect(() => {
        if (itemReport) {
            setItem(itemReport)
        }
    }, [itemReport])

    useEffect(() => {
        if (!open) {
            setImages([])
            setHasLocalChanges(false)
            setEditingIndex(null)
            setEditingText('')
        }
    }, [open])

    const deleteMessage = (indexToDelete) => {
        setConfirm(
            'Confirmar Borrado',
            'Confirme el borrado del mensaje. La acción no se podrá reponer.',
            () => {
                const itemCache = {
                    ...item,
                    backlogList: item.backlogList.filter((_, i) => i !== indexToDelete)
                }
                setItem(itemCache)
                setHasLocalChanges(true)
            }
        )
    }

    const addImage = () => {
        const imageButton = document.getElementById('imageBacklog')
        if (imageButton) {
            imageButton.click()
        }
    }

    const getImages = async (e) => {
        const file = e.target.files?.[0]
        if (file) {
            const urlBase64 = await imageToBase64(file)
            setGalleryImageToEdit(urlBase64)
            setOpenCamera(true)
        }
        if (e.target) e.target.value = ''
    }

    const handleImageCapture = (imageBase64, commentText) => {
        if (typeof imageBase64 === 'string' && imageBase64.startsWith('data:image')) {
            const comment = commentText && commentText.trim() !== '' ? commentText.trim() : 'Hallazgo registrado con imagen'

            const backlog = {
                user: {
                    _id: userData._id,
                    name: userData.name,
                    lastName: userData.lastName
                },
                images: [{
                    urlBase64: imageBase64,
                    url: null
                }],
                message: comment,
                id: Date.now()
            }

            const updatedItem = {
                ...item,
                backlogList: [...(item?.backlogList || []), backlog]
            }

            setItem(updatedItem)
            setHasLocalChanges(true)
            setGalleryImageToEdit(null)
            setOpenCamera(false)
            setSeleccionComponente('mensajes')
        } else {
            console.error('El formato de la imagen Base64 no es válido')
        }
    }

    const openImage = (images, index) => {
        setOpenImageModel(true)
        setImagesSelected(images)
        setIndexImage(index)
    }

    const closeImage = () => {
        setOpenImageModel(false)
        setImagesSelected([...images])
        setIndexImage(0)
    }

    const handleOpenCamera = (e) => {
        if (e) e.preventDefault()
        setGalleryImageToEdit(null)
        setOpenCamera(true)
    }

    const handleCloseCamera = (e) => {
        if (e) e.preventDefault()
        setOpenCamera(false)
        setGalleryImageToEdit(null)
    }

    // Helper to clean Azure SAS token from URL for caching key
    const cleanAzureUrl = (url) => {
        if (!url) return ''
        const separatorIndex = url.indexOf('?')
        return separatorIndex !== -1 ? url.substring(0, separatorIndex) : url
    }

    return (
        <Dialog
            open={open}
            onClose={() => close(item, index, hasLocalChanges)}
            sx={{
                '& .MuiDialog-container': {
                    '& .MuiPaper-root': {
                        width: '100%',
                        maxWidth: '700px',
                        height: '100%',
                        maxHeight: '600px',
                        display: 'flex',
                        flexDirection: 'column'
                    }
                }
            }}
        >
            {openImageModel && <ImageAstDialog
                open={openImageModel}
                handleClose={closeImage}
                images={imagesSelected}
                indexSlide={indexImage}
            />}

            <Fab
                onClick={() => close(item, index, hasLocalChanges)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                    zIndex: 1
                }}
                size="small"
            >
                <Close sx={{ color: '#ccc' }} />
            </Fab>

            {seleccionComponente === 'nuevoBacklog'
                ? <DialogTitle>Hallazgo</DialogTitle>
                : <DialogTitle>Hallazgos / Mensajes</DialogTitle>
            }

            <DialogContent sx={{ flexGrow: 1, p: 2, overflowY: 'auto' }}>
                {seleccionComponente === 'nuevoBacklog'
                    ? (
                        <>
                            <DialogContentText sx={{ mb: 2 }}>
                                {item && item.strpmdesc} / {item && item.taskdesc}
                            </DialogContentText>

                            {/* Action area for capturing/selecting photos for new finding */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 2.5,
                                p: 4,
                                my: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: '12px',
                                border: '2px dashed #e0e0e0',
                                textAlign: 'center'
                            }}>
                                <Typography variant="subtitle1" sx={{ color: '#333', fontWeight: 'bold' }}>
                                    Crear Nuevo Hallazgo
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#666', maxWidth: 400 }}>
                                    Tome una foto con la cámara o seleccione una imagen de la galería para registrar el hallazgo con sus comentarios.
                                </Typography>

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                                    {/* Prominent Camera Button */}
                                    <Button
                                        variant="contained"
                                        onClick={handleOpenCamera}
                                        startIcon={<FontAwesomeIcon icon={faCamera} />}
                                        sx={{
                                            bgcolor: '#be2e26',
                                            color: '#fff',
                                            px: 3.5,
                                            py: 1.4,
                                            borderRadius: '10px',
                                            fontWeight: 'bold',
                                            fontSize: '1rem',
                                            boxShadow: '0 4px 14px rgba(190, 46, 38, 0.35)',
                                            textTransform: 'none',
                                            '&:hover': { bgcolor: '#9c241e' }
                                        }}
                                    >
                                        Tomar Foto / Editar
                                    </Button>

                                    {/* Less prominent Gallery Button */}
                                    <IconButton
                                        onClick={addImage}
                                        title="Seleccionar de la galería"
                                        sx={{
                                            bgcolor: '#ffffff',
                                            border: '1px solid #ddd',
                                            color: '#555',
                                            p: 1.6,
                                            borderRadius: '10px',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                                            '&:hover': { bgcolor: '#f0f0f0', color: '#be2e26' }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faImage} size="lg" />
                                    </IconButton>

                                    <input
                                        onChange={getImages}
                                        type="file"
                                        style={{ display: 'none' }}
                                        id={'imageBacklog'}
                                        accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
                                    />
                                    {openCamera && (
                                        <CameraModal
                                            open={openCamera}
                                            handleClose={handleCloseCamera}
                                            onImageCapture={handleImageCapture}
                                            initialImageSrc={galleryImageToEdit}
                                        />
                                    )}
                                </Box>
                            </Box>

                            {/* User Data Info */}
                            <Box sx={{ fontSize: 12, color: '#555', mt: 3, p: 1.5, bgcolor: '#fafafa', borderRadius: '8px' }}>
                                <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block', mb: 0.5, color: '#333' }}>
                                    Datos de usuario:
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>Nombre:</Grid>
                                    <Grid item xs={8}>{userData.name} {userData.lastName}</Grid>
                                    <Grid item xs={4}>Rut:</Grid>
                                    <Grid item xs={8}>{userData.rut}</Grid>
                                </Grid>
                            </Box>
                        </>
                    )
                    : (
                        <>
                            <DialogContentText sx={{ pb: 2 }}>
                                {item && item.strpmdesc} / {item && item.taskdesc}
                            </DialogContentText>
                            {item && item.backlogList && (item.backlogList.length > 0)
                                ? <div>
                                    {
                                        item.backlogList.map((el, i) => {
                                            return (
                                                <div key={i} style={{ position: 'relative', border: '1px #ccc solid', borderRadius: 8, padding: 10, marginBottom: 15 }}>
                                                    <Grid container spacing={2}>
                                                        {(el.images && el.images.length > 0) &&
                                                            <Grid item xs={12} sm={7}>
                                                                <Grid container spacing={1}>
                                                                    {
                                                                        el.images.map((image, index) => {
                                                                            let imgSrc = image?.urlBase64
                                                                            if (!imgSrc) {
                                                                                imgSrc = (typeof image === 'string') ? image : (image?.url || '')
                                                                            }
                                                                            if (imgSrc && (imgSrc.includes('/undefined') || imgSrc.endsWith('undefined.jpg') || imgSrc === 'undefined')) {
                                                                                imgSrc = null
                                                                            }

                                                                            return (
                                                                                <Grid item xs={el.images.length === 1 ? 12 : 6} key={index}>
                                                                                    {
                                                                                        imgSrc
                                                                                            ? <img
                                                                                                src={imgSrc}
                                                                                                style={{ width: '100%', maxHeight: 250, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                                                                                                onClick={() => {
                                                                                                    openImage(el.images.map(img => {
                                                                                                        let srcForModal = img?.urlBase64
                                                                                                        if (!srcForModal) {
                                                                                                            srcForModal = (typeof img === 'string') ? img : (img?.url || '')
                                                                                                        }
                                                                                                        if (srcForModal && (srcForModal.includes('/undefined') || srcForModal.endsWith('undefined.jpg') || srcForModal === 'undefined')) {
                                                                                                            srcForModal = null
                                                                                                        }
                                                                                                        return srcForModal
                                                                                                    }), index)
                                                                                                }}
                                                                                            />
                                                                                            : <div style={{ padding: 10, border: '1px dashed #ccc', textAlign: 'center' }}>
                                                                                                <p style={{ fontSize: 10, fontWeight: 'bold' }}>Error al cargar imágen.</p>
                                                                                            </div>
                                                                                    }
                                                                                </Grid>
                                                                            )
                                                                        })
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        }

                                                        {/* Right Side: Content */}
                                                        <Grid item xs={12} sm={(el.images && el.images.length > 0) ? 5 : 12}>
                                                            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 100 }}>
                                                                <div style={{ flexGrow: 1 }}>
                                                                    <p style={{ margin: '0 0 4px 0', fontSize: 13, fontWeight: 'bold', color: '#be2e26' }}>
                                                                        {el.user ? `${el.user.name} ${el.user.lastName}` : 'Usuario Anónimo'}
                                                                    </p>
                                                                    {editingIndex === i ? (
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                                                            <TextField
                                                                                fullWidth
                                                                                multiline
                                                                                size="small"
                                                                                value={editingText}
                                                                                onChange={(e) => setEditingText(e.target.value)}
                                                                                sx={{
                                                                                    '& .MuiInputBase-root': { fontSize: '0.85rem' }
                                                                                }}
                                                                            />
                                                                            <IconButton
                                                                                onClick={() => handleSaveEditMessage(i)}
                                                                                color="success"
                                                                                size="small"
                                                                                title="Guardar cambios"
                                                                            >
                                                                                <FontAwesomeIcon icon={faCheck} />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                onClick={() => setEditingIndex(null)}
                                                                                color="error"
                                                                                size="small"
                                                                                title="Cancelar edición"
                                                                            >
                                                                                <Close style={{ fontSize: 16 }} />
                                                                            </IconButton>
                                                                        </Box>
                                                                    ) : (
                                                                        <p style={{ margin: 0, fontSize: 15, whiteSpace: 'pre-line', color: '#333' }}>
                                                                            {el.message}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                                <div style={{ textAlign: 'right', marginTop: 10 }}>
                                                                    <p style={{ margin: 0, fontSize: 11, color: '#777', fontStyle: 'italic' }}>
                                                                        {dateWithTime(el.id)}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>

                                                    {
                                                        (el.user && userData._id === el.user._id && isOperator && !isUniversalChief && userHasStarted) && (
                                                            <>
                                                                <IconButton
                                                                    sx={{ position: 'absolute', top: -5, right: 28, backgroundColor: '#fff', boxShadow: '0px 2px 4px rgba(0,0,0,0.2)' }}
                                                                    size="small"
                                                                    onClick={() => {
                                                                        if (editingIndex === i) {
                                                                            setEditingIndex(null)
                                                                        } else {
                                                                            handleStartEditMessage(i, el.message)
                                                                        }
                                                                    }}
                                                                    title="Editar comentario"
                                                                >
                                                                    <FontAwesomeIcon icon={faPen} style={{ fontSize: 11, color: '#1976d2' }} />
                                                                </IconButton>
                                                                <IconButton
                                                                    sx={{ position: 'absolute', top: -5, right: -5, backgroundColor: '#fff', boxShadow: '0px 2px 4px rgba(0,0,0,0.2)' }}
                                                                    size="small"
                                                                    onClick={() => { deleteMessage(i) }}
                                                                    title="Eliminar comentario"
                                                                >
                                                                    <Close sx={{ fontSize: 16, color: '#be2e26' }} />
                                                                </IconButton>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                : <p>Sin mensajes registrados.</p>
                            }
                        </>
                    )
                }
            </DialogContent>

            {/* DialogActions for buttons */}
            {(isOperator && !isUniversalChief && report.level < 4 && userHasStarted) && (
                <DialogActions sx={{ p: 2, borderTop: '1px solid #eee' }}>
                    <ButtonGroup variant="outlined" aria-label="Basic button group" fullWidth>
                        <Button onClick={() => { setSeleccionComponente('nuevoBacklog') }}>Nuevo Hallazgo</Button>
                        <Button onClick={() => { setSeleccionComponente('mensajes') }}>Mensajes</Button>
                    </ButtonGroup>
                </DialogActions>
            )}
        </Dialog>
    )
}

export default BacklogMessageDialog
